<template>
    <div class="mini-comparisons">
        <a :href="url" data-newwindow class="comparisons-link mini-link">
            <img :src="imgPath" alt="">
            <span v-if="countCompareItems" class="count">{{countCompareItems}}</span>
        </a>
        <div class="tooltip">
            {{compareTitle}}
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    /**
     * Компонент для отображения в шапке сайта количества товаров добавленых в сравнение
     *
     * @vuedoc
     * @module vue:components/MiniCompare
     * @exports vue:components/MiniCompare
     */

    export default {
        name: "mini-top-compare",

        components: {
        },

        props: [
            'title', 'img_src', 'url'
        ],
        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property  {string} compareTitle - Значение в тултипе в зависемости от языка на сайте
         * @property  {string} imgPath - Значение картинки на значке сравнения (почему то только в сравнениях значок представлен
         *                      изображением, а в корзине и избранным зависет от класса :) )
         */
        data() {
            return {
                compareTitle: this.title,
                imgPath: this.img_src,
            }
        },

        computed: {
            ...mapGetters('compare', [
                'compareItems',
            ]),
            /**
             *  Вычисляемое свойство которое получает список товаров в сравнениях
             *
             * @method getCompareItems
             */
            getCompareItems() {
                if(typeof this.compareItems !== 'undefined') {
                    return this.compareItems;
                }
            },

            /**
             *  Вычисляемое свойство которое определяет количество товаров в сравнениях
             *
             * @method countCompareItems
             */
            countCompareItems() {
                return _.keys(this.compareItems).length;
            },
        },

        mounted(){
        },

        methods: {
        }
    }


</script>
